<script setup lang="ts">
import ConfirmIdentityDialog from '@/components/ConfirmIdentityDialog.vue'
import ToastHost from '@/components/ToastHost.vue'
</script>

<template>
  <RouterView />
  <ConfirmIdentityDialog />
  <ToastHost />
</template>
